import { BIGQUERY_EXPORT, PARTNERS_WITH_PUBLIC_KEY } from 'utils/constants/partners.constant';


export const jobTypes = {
  EXPORTS: { key: 'EXPORTS', label: 'Exports' },
  OFFLINE_CONVERSIONS: { key: 'OFFLINE_CONVERSIONS', label: 'Offline Conversions' },
  QUESTION_USER_LIST: { key: 'QUESTION_USER_LIST', label: 'Question User List' },
  USER_LIST: { key: 'USER_LIST', label: 'User List' },
};

export const jobRunTypes = {
  FULL_REFRESH: { key: 'FULL_REFRESH', label: 'Full Refresh' },
  INCREMENTAL: { key: 'INCREMENTAL', label: 'Incremental' },
  UNKNOWN_JOB_RUN_TYPE: { key: 'UNKNOWN_JOB_RUN_TYPE', label: 'Unknown job run type' },
};

export const jobCategories = {
  pageData: 'Page Data',
};

export const partnerTypes = {
  USER_LIST: 'USER_LIST',
  OFFLINE_CONVERSIONS: 'OFFLINE_CONVERSIONS',
  QUESTION_USER_LIST: 'QUESTION_USER_LIST',
  EXPORTS: 'EXPORTS',
};

export const exportParams = {
  S3_EXPORT_PATH: 'S3 Export Path',
  GCS_EXPORT_PATH: 'GCS Export Path',
  AZURE_EXPORT_PATH: 'Azure Export Path',
  AZURE_STORAGE_ACCOUNT: 'Storage Account',
  AZURE_STORAGE_CONTAINER: 'Storage Container',
  CSV_EXPORT: 'CSV Export',
  CUSTOM_EXPORT_FILE_NAME: 'Custom Export File Name',
};

export const exportParameterMap = {
  [BIGQUERY_EXPORT]: ['Dataset Name', 'Table Name'],
  FacebookAMAPI: ['Table Name'],
  S3Export: ['S3 Prefix'],
  AmcExport: ['Dataset Id', 'Dataset Type'],
  'S3 IAM Role Export': [exportParams.S3_EXPORT_PATH, exportParams.CSV_EXPORT],
  'GCS Export': [exportParams.GCS_EXPORT_PATH, exportParams.CSV_EXPORT],
  'Azure Export': [exportParams.AZURE_STORAGE_ACCOUNT, exportParams.AZURE_STORAGE_CONTAINER,
    exportParams.AZURE_EXPORT_PATH],
  'Azure User Delegation SAS': [exportParams.AZURE_STORAGE_ACCOUNT, exportParams.AZURE_STORAGE_CONTAINER,
    exportParams.AZURE_EXPORT_PATH],
};

// Clean room names which can export datasets
export const datasetExportEnabledCRs = [
  'FacebookAMAPI',
  'AmcExport',
];

// Dataset types for the clean rooms which can export datasets
export const exportEnabledDatasetTypes = {
  DIMENSION: { key: 'DIMENSION', label: 'Dimension' },
  FACT: { key: 'FACT', label: 'Fact' },
};

export const addCustomFileNameParam = (paramList, partnerName) => {
  // Custom file name is now always enabled, removed the isCustomFileNameEnabled parameter
  if (!PARTNERS_WITH_PUBLIC_KEY.includes(partnerName)) {
    return paramList;
  }

  const csvExportIndex = paramList?.indexOf(exportParams.CSV_EXPORT);
  if (csvExportIndex !== -1) {
    // Insert CUSTOM_EXPORT_FILE_NAME before CSV_EXPORT
    return [
      ...paramList.slice(0, csvExportIndex),
      exportParams.CUSTOM_EXPORT_FILE_NAME,
      ...paramList.slice(csvExportIndex),
    ];
  }
  // CSV_EXPORT doesn't exist, add CUSTOM_EXPORT_FILE_NAME at the end
  return [...paramList, exportParams.CUSTOM_EXPORT_FILE_NAME];
};
